import Picker from '../../picker/locale/en_US';
import DatePicker from '../../date-picker/locale/en_US';
import DatePickerView from '../../date-picker-view/locale/en_US';
import Menu from '../../menu/locale/en_US';
import Calendar from '../../calendar/locale/en_US';
import SearchBar from '../../search-bar/locale/en_US';
import InputItem from '../../input-item/locale/en_US';
import Pagination from '../../pagination/locale/en_US';
import PullToRefresh from '../../pull-to-refresh/locale/en_US';
import ActionSheet from '../../action-sheet/locale/en_US';

export default {
  locale: 'en_US',
  Picker,
  DatePicker,
  DatePickerView,
  Menu,
  Calendar,
  SearchBar,
  InputItem,
  Pagination,
  PullToRefresh,
  ActionSheet
};
